module.exports = __webpack_public_path__ + "media/personas/bg-content-talking-b8d7137d.jpg";